import logo from './logo.svg';
import './App.css';
import {useState,useEffect} from "react"
import ReduxWrapper from './components/ReduxWrapper';
import Navigation from './navigation';
import { Box, CssBaseline, ThemeProvider } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Header from './components/Headers';
import LoadingPage from './components/common/loading';
import DrawerCompnent from './components/Drawer';
function App() {
   const theme = useTheme({
    breakpoints: { values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 } },
  });
  const [openDrawer,setOpen]=useState(true);
  const toggleDrawer=()=>setOpen(s=>!s)
  return (
    // <div className="App">
      <ThemeProvider theme={theme}>
        <ReduxWrapper>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline  />
          <DrawerCompnent open={openDrawer} toggleDrawer={toggleDrawer}/>
          <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
            theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
            width:`calc(100% - 240px)`,
          }}
        >
          <Header drawerStatus={openDrawer} toggleDrawer={toggleDrawer} />
          <Navigation />
        </Box>
          </Box>
        </ReduxWrapper>
      </ThemeProvider>
    // </div>
  );
}

export default App;
